import React, { useEffect, useRef } from 'react'
import { CKEditor } from 'ckeditor4-react'

const CkItem = ({ formData, setFormData, keyT, title }) => {
    const editorRef = useRef(null);

    const handleEditorChange = (evt) => {
        setFormData(prevData => ({
            ...prevData,
            [keyT]: evt.editor.getData()
        }));
    };

    const handleEditorInstance = (editor) => {
        editorRef.current = editor;
    };

    useEffect(() => {
        if (editorRef.current && formData[keyT] !== undefined) {
            if (editorRef.current.getData() !== formData[keyT]) {
                editorRef.current.setData(formData[keyT] || '');
            }
        }
    }, [formData, keyT]);

    return (
        <div className="form-group mb-3">
            <label htmlFor={keyT} className="mb-2">{title}</label>
            <CKEditor
                key={`editor-${keyT}`}
                data={formData[keyT] || ''}
                onChange={handleEditorChange}
                onInstanceReady={(evt) => handleEditorInstance(evt.editor)}
                config={{
                    language: 'tr',
                    toolbar: [
                        ['Bold', 'Italic', 'Underline', 'Strike', '-', 'TextColor', 'BGColor'],
                        ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent'],
                        ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
                        ['Link', 'Unlink'],
                        ['Image', 'Table'],
                        ['Styles', 'Format', 'Font', 'FontSize'],
                        ['TextColor', 'BGColor'],
                        ['Maximize', 'Source']
                    ],
                    height: 200,
                    placeholder: `${title}...`
                }}
            />
        </div>
    )
}

export default CkItem